module.exports = __webpack_public_path__ + "img/1288.0f482c5b.png";